module.exports = __webpack_public_path__ + "img/yml_gallery2.617cc615.jpg";